import httpClient from '@/lib/httpClient.js'
import { useQuery } from '@tanstack/react-query'
import useModelsFingerprint from '@/services/api/model/useModelsFingerprint'

/**
 * GET /team/cash-flow/available-to-spend — "what can I spend right now?".
 * As-at-today; no period params, no vault filter.
 */
export default function useGetAvailableToSpend({ enabled = true } = {}) {
  const modelsFingerprint = useModelsFingerprint()

  const fetchData = async () => {
    const response = await httpClient.get('team/cash-flow/available-to-spend')
    return response.data
  }

  return useQuery({
    queryKey: ['available-to-spend', { modelsFingerprint }],
    queryFn: fetchData,
    staleTime: Infinity,
    enabled,
  })
}
